const PostPaddingContainer = ({ children, postPadding, classNames }: any) => {
  return (
    <div className={classNames} style={{ paddingLeft: postPadding, paddingRight: postPadding }}>
      {children}
    </div>
  );
};

export default PostPaddingContainer;
